<!-- Feedback page -->
<section>

    <!-- Page Title -->
    <div class="title text-center content-box-header">
        <h2 class="container title bold">Module {{moduleNumber}} - Quiz</h2>
        <h3 class="container sub-title bold">Percentage: {{percentage}}%</h3>
        <h3 *ngIf="percentage < 80">You did not pass, please review and get an 80% to continue.</h3>
        <h3 *ngIf="percentage >= 80">You passed! Click continue to continue to the next module.</h3>
    </div>
    <br>

    <!-- Quiz Questions -->
    <div *ngFor="let question of questions | slice:0:10; let i=index;">
        <div class="container">

            <!-- Conditional Border -->
            <div class="card text-left" [ngClass]="answers[i] !== correctAnswers[i] ? 'border-danger' : 'border-success'">
                <div class="card-header" [ngClass]="answers[i] !== correctAnswers[i] ? 'color-incorrect' : 'color-correct'">
                    <h1 class="bolder">Question {{i+1}}:</h1>
                    <p class="bold question">{{question.question}}</p>
                </div>

                <!-- Quiz Choices -->
                <div class="card-body">
                    <div *ngFor="let answer of question.answers; let j=index">
                        <input type="radio" disabled [checked]="answers[i] === j">
                        <label class="bold">&nbsp;&nbsp;{{letterArray[j]}}.&nbsp;</label>
                        <span>{{answer}}</span>
                    </div>
                </div>

                <!-- Hint Only if Wrong and not Null -->
                <div class="card-footer bold" *ngIf="question.hint && answers[i] !== correctAnswers[i]">
                    <span class="bolder">HINT:&nbsp;&nbsp;</span> {{ question.hint }}
                </div>
            </div>
        </div>
        <br>
    </div>
</section>
